import React from "react";
import Button from "../UI/Button/Button";
import UpRightArrowWhite from "../../icons/arrows/upRightArrowWhite.svg";

import * as styles from "./SecondaryNav.module.scss";

const SecondaryNav = ({ Name, Stock, modelo }) => {
  return (
    <section className={`${styles.productBannerTop} flex`}>
      <div className="container m0-auto">
        <div className="flex">
          <div className={styles.container_model}>
            <h4>{Name}</h4>
            <h6>{modelo}</h6>
          </div>

          {Stock === "Sin Stock" ? (
            <Button
              text={"Sin Stock"}
              color="yellow"
              icon={UpRightArrowWhite}
            />
          ) : (
            <Button text={"Comprar"} color="yellow" icon={UpRightArrowWhite} />
          )}
        </div>
      </div>
    </section>
  );
};

export default SecondaryNav;
